import { useEffect, useRef, useState } from "react";
import BannerThree from "./widget/BannerThree";
import Scholatic from "./widget/scholatic";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import InfoTwo from "./widget/InfoTwo";
import TestimonialsThree from "./widget/TestimonialsThree";
import VideoOne from "./widget/VideoOne";
import AboutThree from "./widget/AboutThree";
import Animation from "../helper/Animation";
import CoScholatic from "./widget/coscholatic";
import RootLayout from "./layout";
import CertificateTwo from "./widget/CertificateTwo";
import AdmissionModal from "./widget/AdmissionModal";
import SEO from "./SEO";



const Home = () => {
  const [showModal, setShowModal] = useState(false);
  const ranOnceRef = useRef(false);

  // useEffect(() => {
  //   if (typeof window === "undefined") return;
  //   if (ranOnceRef.current) return;
  //   ranOnceRef.current = true;

  //   let timer;
  //   try {
  //     const shown = window.sessionStorage.getItem("admissionModalShown");
  //     if (!shown) {
  //       timer = setTimeout(() => {
  //         setShowModal(true);
  //         window.sessionStorage.setItem("admissionModalShown", "1");
  //       }, 800);
  //     }
  //   } catch {
  //     timer = setTimeout(() => setShowModal(true), 800);
  //   }
  //   return () => clearTimeout(timer);
  // }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowModal(true);
  //   }, 800); // optional delay

  //   return () => clearTimeout(timer);
  // }, []);

  return (
    <>
      <SEO
        title="National Public School Kudlu | Best CBSE School in Bengaluru"
        description="National Public School Kudlu offers quality CBSE education with experienced faculty, modern
infrastructure, sports, and holistic development. Admissions Open."
        keywords="National Public School Kudlu, NPS Kudlu,CBSE School Kudlu,Best CBSE School in Kudlu, Best CBSE School in Bengaluru, Top School in Kudlu, CBSE School Near Me, CBSE School Bangalore
, Schools in Kudlu
, Admissions Open CBSE School, Best School in Bangalore"
        canonical="https://npskudlu.com/"
      />
      <RootLayout>
        <Animation />
        <HeaderOne />
        <BannerThree />
        <InfoTwo />
        <AboutThree />
        <VideoOne />
        <CertificateTwo />
        <Scholatic />
        <CoScholatic />
        <TestimonialsThree />
        <FooterThree />
      </RootLayout>

      <AdmissionModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default Home;
